import { Navigate } from 'react-router-dom';
import NavBar from '../../components/NavBar/NavBar';
import UserControl from '../../components/Tables/UserControl';
import { Container } from 'react-bootstrap';

const Home = ({ auth, onLogout }) => {
    if (!auth.isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return (
        <>
            <NavBar auth={auth} onLogout={onLogout} />
            <Container fluid className="py-4 mt-4">
                {auth.user?.role === 'admin' ? (
                    <UserControl />
                ) : (
                    <Navigate to="/dashboard" replace />
                )}
            </Container>
        </>
    );
};

export default Home;